import { Dispatch, ThunkAction } from '../../../../../../types/actions';
import { TBoardId } from '../../../../../../types/types';
import { TCardField } from '../../../store/listViewBoard/types';
import { shownFieldToggle } from '../../../effects/shownFieldToggle';

export const onClick = (
     boardId: TBoardId,
     field: TCardField
): ThunkAction => {
    const action = (dispatch: Dispatch) => {
        dispatch(shownFieldToggle(boardId, field));
    };
    return action;
};
